import React, { useCallback } from 'react';

import { TopLevelSpacer } from '@atlaskit/navigation-system/side-nav-items/top-level-spacer';

import GlobalShortcuts, {
	type GlobalShortcutsProps,
	productLinksWorkspaceCloudIdFilter,
	useOrderedAppShortcuts,
} from '@atlassian/global-shortcuts';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data';

import { useShortcutItemsConfig } from './hooks/useShortcutItemsConfig';

type GlobalAppShortcutsProps = {
	orderedMenuConfig?: { menuId: string; visible: boolean }[];
	onUpdateGetFilteredProductLinks?: GlobalShortcutsProps['onUpdateGetFilteredProductLinks'];
};

export const GlobalAppShortcuts = ({
	orderedMenuConfig = [],
	onUpdateGetFilteredProductLinks,
}: GlobalAppShortcutsProps) => {
	const { cloudId, orgId, userId } = useSessionData();

	const updateGetFilteredProductLinks = useCallback(
		(getFilteredProductLinks) => {
			if (onUpdateGetFilteredProductLinks) {
				onUpdateGetFilteredProductLinks(getFilteredProductLinks);
			}
		},
		[onUpdateGetFilteredProductLinks],
	);

	const shortcutItemsConfig = useShortcutItemsConfig();

	// Sort shortcut items based on the ordered menu config
	const orderedShortcuts = useOrderedAppShortcuts(shortcutItemsConfig, orderedMenuConfig);

	const productLinksFilter = cloudId ? productLinksWorkspaceCloudIdFilter(cloudId) : undefined;
	const userIdOrUndefined = fg('platform_navigation_data_provider_caching_support')
		? userId || undefined
		: undefined;

	return (
		<>
			<GlobalShortcuts
				testId="global-app-shortcuts"
				cloudId={cloudId}
				orgId={orgId}
				userId={userIdOrUndefined}
				shortcutItems={orderedShortcuts}
				promoteSite
				product="confluence"
				productLinksFilter={productLinksFilter}
				onUpdateGetFilteredProductLinks={updateGetFilteredProductLinks}
			/>
			{orderedShortcuts.length > 0 && <TopLevelSpacer />}
		</>
	);
};
